var styles = {
  "Navigation": "pb-Navigation__Navigation",
  "chevronWrapper": "pb-Navigation__chevronWrapper",
  "text": "pb-Navigation__text",
  "Navigation--sticky": "pb-Navigation__Navigation--sticky",
  "navigationContent": "pb-Navigation__navigationContent",
  "wrapper": "pb-Navigation__wrapper",
  "Navigation--noBack": "pb-Navigation__Navigation--noBack",
  "stickySpace": "pb-Navigation__stickySpace"
};
export default styles;